/**
 * Extracts a substring from a string using a regular expression.
 *
 * e.g: Trim size from style number.
 * @param {string} str The input string to extract from.
 *
 * @returns {string} The extracted substring.
 * @example
 * extractString("ZDNV310008_Black_3X") // returns "ZDNV310008_Black"
 * extractString("BR22300N") // returns "BR22300N"
 */
const extractStyleNumber = (str) => {
  if (
    typeof str !== 'string' ||
    str === '' ||
    str === null ||
    str === undefined
  ) {
    throw new Error('Input must be a non-empty string');
  }
  const regex = /^[A-Z0-9a-z]+_[A-Z0-9a-z]+/i;
  return str.match(regex) ? str.match(regex)[0] : str;
};

export default extractStyleNumber;
